import { authFetch } from './authFetch';
import { handleUnauthorizedRedirect } from './authRedirect';
export async function sendChatMessageDirect(movieId, body) {
    const response = await authFetch(`/api/movies/${movieId}/chat/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    if (response.status === 401) {
        handleUnauthorizedRedirect();
        return null;
    }
    if (!response.ok) {
        console.error('[aiChatClient] send failed', response.status, await response.text());
        return null;
    }
    return (await response.json());
}
